import { Button, Col, Modal, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/store";
import {
  addQuestionCategory,
  getQuestionCategory,
} from "../../features/jobSlice";
import { toast } from "react-toastify";

const JobApplication = () => {
  const dispatch = useAppDispatch();
  const [show, setShow] = useState(false);
  const [category, setQuestionCategory] = useState("");
  const [searchTerm, setSearchTerm] = useState(""); // Search state

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { questionCategory } = useAppSelector((state) => state.job);

  useEffect(() => {
    dispatch(getQuestionCategory());
  }, [dispatch]);

  const handleSaveQuestionCategory = () => {
    let data = {
      category_name: category,
    };

    dispatch(addQuestionCategory(data))
      .unwrap()
      .then(() => {
        setQuestionCategory("");
        handleClose();
        dispatch(getQuestionCategory());
        toast.success("Question category added successfully!");
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  if (!questionCategory) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <p>Loading...</p>
      </div>
    );
  }

  // Filter categories by search term
  const filteredCategories = questionCategory.data.filter((item: any) =>
    item.category_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <Row>
        <Col md={9} sm={12} className="p-3">
          <div className="d-flex flex-row justify-content-between pt-3">
            <div>
              <Button
                variant="secondary"
                className="rounded-0 text-white"
                onClick={handleShow}
              >
                Add Question Category
              </Button>
            </div>
            <div>
              <div
                className="input-group rounded border border-secondary-subtle shadow-sm"
                style={{ maxWidth: "300px" }}
              >
                <span className="input-group-text bg-white border-0">
                  <i className="bi bi-search text-muted"></i>
                </span>
                <input
                  type="text"
                  className="form-control border-0"
                  placeholder="Search"
                  aria-label="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>
          <hr />
          <div className="job-settings-table">
            <Row className="mt-2 bg-primary text-white p-3 rounded">
              <div className="d-flex flex-row justify-content-between">
                <Col md={4}>Category</Col>
                <Col md={4}>Action</Col>
              </div>
            </Row>
            {filteredCategories.length > 0 ? (
              filteredCategories.map((items: any) => (
                <Row
                  key={items.id}
                  className="mt-2 bg-white text-dark p-3 rounded col-rows"
                >
                  <div className="d-flex flex-row justify-content-between">
                    <Col md={4}>{items.category_name}</Col>
                    <Col md={4}>
                      <a
                        href={`job-application/${items.id}`}
                        className="btn btn-secondary text-white rounded-0"
                      >
                        View/Add Questions
                      </a>
                    </Col>
                  </div>
                </Row>
              ))
            ) : (
              <Row className="mt-2 bg-white text-dark p-3 rounded col-rows">
                <Col md={12} className="text-center">
                  No Question Categories Available
                </Col>
              </Row>
            )}
          </div>
        </Col>
        <Col md={3} sm={12} style={{ backgroundColor: "#C2CFE0" }}>
          <div className="p-3">
            <div className="mb-2">
              <h5>Configure your Job Type</h5>
            </div>
            <p>
              Do you wish to send a warm and personalized acknowledgement email
              to every candidate who applies to your company? Do you wish to
              send a policy guide to help any employee who requests a transfer?
              Email notifications help you customize (almost) every email that
              is sent from Freshteam to candidates, employees, managers etc.
            </p>
          </div>
        </Col>
      </Row>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title>
            <h3 className="title-modal">ADD QUESTION CATEGORY</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>Category</label>
            <input
              type="text"
              className="form-control form-control-lg rounded-0"
              name="category-name"
              value={category}
              onChange={(e) => setQuestionCategory(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 d-flex justify-content-between">
          <Button variant="danger" className="rounded-0" onClick={handleClose}>
            Cancel
          </Button>

          <Button
            variant="secondary"
            className="text-white rounded-0"
            onClick={handleSaveQuestionCategory}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default JobApplication;
